export default __webpack_public_path__ + "static/media/PAFI_Announcement of GMS 2023.f286549f.pdf";